export const Zupy = [

  
  {
    "id": "zupa-1",
    "name": "Wywar / Rosół wegański",
    "category": "ZUPY",
    "shortDesc": "Aromatyczny, pełen smaku wegański wywar.",
    "fullDesc": "Wywar wegański to podstawa wielu dań, które gotuję niemal codziennie. Jego smak może być zarówno intensywny i pełen aromatu, jak i delikatniejszy i subtelniejszy, w zależności od użytych składników. Jest to jedno z dań, które często przygotowuję na obiad. Można go spożywać samodzielnie jako rosół lub wzbogacić o dodatkowe składniki, tworząc pełnowartościową zupę. Przepis inspirowany Jadłonomią i Gotuj w Stylu Eko.",
    "image": "Zupy/wywar_rosol_weganski.jpg",
    "preparation": "Przygotowanie warzyw: Obierz i dokładnie umyj marchewki, pietruszki, selera oraz pora. Pokrój seler i inne większe warzywa na kawałki. Gotowanie wywaru: Umieść wszystkie warzywa w dużym garnku, zalej 2,5 litra zimnej, świeżej wody (lub więcej, jeśli garnek pozwoli). Dodaj przyprawy: goździki, ziele angielskie, pieprz, liście laurowe, czosnek, kurkumę, imbir, lubczyk oraz sól. Doprowadź do wrzenia na średnim ogniu, a potem zmniejsz ogień do minimum, aby bulion pyrkał. Gotuj przez około 3 godziny, aż wywar nabierze pełnego smaku.",
    "ingredients": [
      "2,5 litra zimnej wody",
      "3 marchewki",
      "2 pietruszki",
      "1 bulwa selera",
      "Pasternak (jeśli uda się znaleźć)",
      "Liście i biała część pora",
      "Natka pietruszki",
      "Liście oraz łodyżki świeżego lubczyku",
      "Garść suszonych grzybów lub 3-4 pieczarki",
      "Kilka suszonych pomidorów z oleju lub 2-3 świeże pomidory",
      "1-2 łyżki dobrej jakości oleju",
      "Przyprawy:",
      "4 goździki",
      "6 ziaren ziela angielskiego",
      "10 ziaren pieprzu",
      "4 liście laurowe",
      "2 ząbki czosnku, obrane z łupin",
      "1-2 łyżeczki mielonej kurkumy",
      "Kawałek imbiru o długości 3 cm, pokrojony w plasterki",
      "1 łyżeczka lubczyku (jeśli nie mieliście świeżego)",
      "Sól do smaku"
    ].join("\n"),
    "path": "zupy"
  },
  
  
  {
    "id": "zupa-2",
    "name": "Bulion / Rosół",
    "category": "ZUPY",
    "shortDesc": "Aromatyczny, pełen smaku bulion wzbogacony o kolagen z mięsa.",
    "fullDesc": "Bulion to jedno z podstawowych dań, które gotuję niemal codziennie. Może być bardziej esencjonalny lub łagodniejszy, w zależności od użytych składników. Dzięki mięsu, bulion zyskuje kolagen, który jest korzystny dla zdrowia. Może być spożywany samodzielnie jako rosół lub stanowić bazę do innych zup. Przepis inspirowany Jadłonomią i Gotuj w Stylu Eko.",
    "image": "Zupy/bulion_rosol.jpg",
    "preparation": "Przygotowanie warzyw: Obierz i dokładnie umyj marchewki, pietruszki, selera oraz pora. Pokrój seler na większe kawałki. Przygotowanie mięsa (jeśli używasz): Dokładnie umyj kości lub kawałki mięsa. Gotowanie bulionu: Umieść warzywa i mięso w dużym garnku. Zalej 2,5 litra zimnej, świeżej wody (lub więcej, jeśli garnek pozwala). Dodaj przyprawy: goździki, ziele angielskie, pieprz, liście laurowe, czosnek, kurkumę, imbir, lubczyk oraz sól. Doprowadź do wrzenia na średnim ogniu, po czym zmniejsz ogień do minimum, aby bulion pyrkał. Gotuj przez 4-6 godzin, aby uzyskać esencjonalny smak.",
    "ingredients": [
      "2,5 litra zimnej wody",
      "3 marchewki",
      "2 pietruszki",
      "1 bulwa selera",
      "Pasternak (jeśli uda się znaleźć)",
      "Liście i biała część pora",
      "Natka pietruszki",
      "Liście oraz łodyżki świeżego lubczyku",
      "Opcjonalnie: suszone grzyby, pieczarki, suszone pomidory, świeży pomidor",
      "Mięso (opcjonalnie):",
      "Świeże kości lub",
      "Kawałek żeberka lub",
      "Dwa skrzydełka indyka lub",
      "Inne porcje rosołowe, takie jak kaczka czy perliczka",
      "Przyprawy:",
      "4 goździki",
      "6 ziaren ziela angielskiego",
      "10 ziaren pieprzu",
      "4 liście laurowe",
      "2 ząbki czosnku, obrane z łupin",
      "Kilka kłączy kurkumy lub ½ łyżeczki mielonej kurkumy",
      "Kawałek imbiru o długości 3 cm, pokrojony w plasterki",
      "1 łyżeczka lubczyku (jeśli nie mieliście świeżego)",
      "Sól do smaku"
    ].join("\n"),
    "path": "zupy"
  },
  
  
  {
    "id": "zupa-3",
    "name": "Zupa ogórkowa",
    "category": "ZUPY",
    "shortDesc": "Alternatywa dla tradycyjnej zupy ogórkowej z kwaśną śmietaną.",
    "fullDesc": "Zupa ogórkowa z mleczkiem kokosowym to wyjątkowa alternatywa dla tradycyjnej wersji z kwaśną śmietaną. Połączenie kiszonych ogórków z praktycznie nie wyczuwalnym smakiem kokosa nadaje zupie niepowtarzalny charakter.",
    "image": "Zupy/ogorkowa.jpg",
 
    "preparation": "Obierz ziemniaki, pokrój je w kostkę. Zetrzyj ogórki kiszone na tarce. Pokrój ugotowaną marchewkę z bulionu w drobną kostkę. Gotuj ziemniaki w bulionie przez 15 minut. Zblenduj część zupy, aby ją zagęścić, a następnie dodaj starte ogórki, marchewkę oraz mleczko kokosowe. Gotuj przez kilka minut, dopraw solą i sokiem z kiszonych ogórków.",
    "ingredients": [
      "1¼ - 1½ litra bulionu warzywnego",
      "1-3 ugotowane marchewki z bulionu",
      "5 ziemniaków",
      "5 dużych kiszonych ogórków",
      "1-4 łyżki soku z kiszonych ogórków",
      "1 kartonik mleczka kokosowego (200 ml)",
      "Świeży koperek, posiekany"
    ].join("\n"),
    "path": "zupy"
  },

  {
    "id": "zupa-4",
    "name": "Zupa krem z buraków",
    "category": "ZUPY",
    "shortDesc": "Pyszna, lekko słodkawa zupa z pieczonych i gotowanych buraków, idealna na chłodne dni.",
    "fullDesc": "Zupa krem z buraków to pyszna i zdrowa zupa, której podstawą są pieczone buraki. Ich intensywny kolor i karmelizowany smak nadają zupie wyjątkową głębię. Przygotowana z prostych składników, jest pełna witamin i świetnie rozgrzewa w chłodne dni. Dodatki takie jak kozi serek czy prażone płatki migdałowe nadają zupie elegancki wygląd i smak.",
    "image": "Zupy/zupa_krem_z_burakow.jpg",
    "preparation": "Przygotowanie wywaru: W garnku przygotuj wywar warzywny, dodając również 5-6 obranych, umytych i pokrojonych na ćwiartki buraków. Gotuj do miękkości. Przygotowanie pieczonych buraków: Resztę buraków umyj, obierz i wstaw do naczynia żaroodpornego. Piecz w piekarniku nagrzanym do 180°C przez około 1,5 godziny. Po upieczeniu obierz ze skórki. Przygotowanie zupy: Przecedź wywar, aby pozbyć się resztek warzyw, a następnie wlej go z powrotem do garnka. Dodaj ugotowane warzywa: marchewki, pietruszkę, kawałek selera oraz wszystkie buraki (zarówno gotowane, jak i pieczone). Zblenduj całość na gładką masę. Dopraw solą i pieprzem do smaku. Podanie: Zupę podawaj gorącą, dekorując ją kozim serkiem lub prażonymi płatkami migdałowymi.",
    "ingredients": [
      "Składniki na wywar warzywny bez mięsa",
      "10 buraków (surowych)",
      "Sól do smaku",
      "Pieprz do smaku"
    ].join("\n"),
    "path": "zupy"
  },
  {
    "id": "zupa-5",
    "name": "Grochówka (z namoczonym grochem)",
    "category": "ZUPY",
    "shortDesc": "Sycąca i rozgrzewająca zupa, idealna na zimowe dni.",
    "fullDesc": "Grochówka to sycąca i rozgrzewająca zupa, idealna na zimowe dni. Dodatkowo, groch jest składnikiem niedrogim i łatwo dostępnym, co czyni to danie budżetowym rozwiązaniem na ciepły posiłek.",
    "image": "Zupy/grochowka.jpg",

    "preparation": "W dużym garnku umieść wędzone żeberka, kiełbasę, marchewki, pietruszki, seler, czosnek, liście laurowe oraz ziele angielskie. Zalej całość 2-2,5 litra wody. Doprowadź do wrzenia, zbierając szumowiny. Zmniejsz ogień i gotuj przez około godzinę, aż mięso będzie miękkie. Po godzinie gotowania wyjmij mięso i warzywa, oddziel mięso od kości i pokrój na kawałki. Dodaj groch do wywaru, gotuj przez 30 minut, a następnie dodaj pokrojone ziemniaki i gotuj do miękkości. Na koniec dodaj mięso, warzywa oraz dopraw solą, pieprzem i majerankiem.",
    "ingredients": [
      "500 g grochu łuskanego namoczonego przez noc",
      "500 g wędzonych żeberek wieprzowych lub boczku wędzonego",
      "100 g kiełbasy wędzonej lub białej lub wiejskiej",
      "3 średnie marchewki",
      "2 średnie pietruszki",
      "1 mały seler",
      "2 liście laurowe",
      "5 ziaren ziela angielskiego",
      "2-3 ząbki czosnku",
      "2-2,5 litra wody",
      "2-4 średnie ziemniaki",
      "2-3 łyżki majeranku",
      "sól i pieprz do smaku"
    ].join("\n"),
    "path": "zupy"
  },

 

  {
    "id": "zupa-6",
    "name": "Grochówka (bez namaczania grochu)",
    "category": "ZUPY",
    "shortDesc": "Sycąca i rozgrzewająca zupa, idealna na zimowe dni, szybka do przygotowania.",
    "fullDesc": "Grochówka to klasyczna, sycąca zupa, która rozgrzewa w chłodne dni. Dzięki wędzonemu mięsu i grochowi stanowi idealne danie na zimę. Groch nie musi być namaczany, co sprawia, że jest to szybka wersja grochówki, którą przygotujesz na ostatnią chwilę. Dodatkowo, jej składniki są niedrogie i łatwo dostępne, co czyni ją idealnym rozwiązaniem na budżetowy, ciepły posiłek.",
    "image": "Zupy/grochowka.jpg",
    "preparation": "Groch przepłucz dokładnie na sicie. W dużym garnku umieść wędzone żeberka, kiełbasę, groch, marchewki, pietruszki, seler, czosnek, liście laurowe oraz ziele angielskie. Zalej całość 2-2,5 litra wody. Doprowadź do wrzenia, zbierając szumowiny, które pojawią się na powierzchni. Zmniejsz ogień i gotuj na małym ogniu przez około godzinę, aż mięso będzie miękkie. W międzyczasie obierz i pokrój w kostkę ziemniaki. Pozostaw pokrojone ziemniaki w świeżej wodzie, żeby nie ściemniały. Po godzinie gotowania wyjmij z bulionu mięso i marchewkę, pietruszkę i seler (por zutylizuj). Oddziel mięso od kości i pokrój na kawałki. Kiełbasę pokrój w kostkę, a warzywa w drobną kosteczkę. Do wywaru dodaj pokrojone ziemniaki (bez wody) i gotuj około 15 minut (do miękkości). Dodaj pokrojone mięso i warzywa z powrotem do zupy. Dopraw solą, pieprzem i majerankiem do smaku. Grochówka jest gotowa do podania. Podawaj ją gorącą, najlepiej z kawałkiem świeżego chleba.",
    "ingredients": [
      "500 g grochu łuskanego",
      "500 g wędzonych żeberek wieprzowych lub boczku wędzonego",
      "100 g kiełbasy wędzonej lub białej lub wiejskiej",
      "3 średnie marchewki",
      "2 średnie pietruszki",
      "1 mały seler",
      "2 liście laurowe",
      "5 ziaren ziela angielskiego",
      "2-3 ząbki czosnku",
      "2-2,5 litra wody",
      "2-4 średnie ziemniaki",
      "2-3 łyżki majeranku",
      "sól i pieprz do smaku"
    ].join("\n"),
    "path": "zupy"
  },
  
  {
    "id": "zupa-7",
    "name": "Zupa soczewicowa",
    "category": "ZUPY",
    "shortDesc": "Sycąca i rozgrzewająca zupa z czerwonej soczewicy, bogata w białko roślinne.",
    "fullDesc": "Zupa soczewicowa to idealne danie na chłodne dni, pełne smaku i wartości odżywczych. Dzięki czerwonej soczewicy jest bogata w białko roślinne, a dodatek warzyw i aromatycznych przypraw nadaje jej głęboki smak. To zdrowa, sycąca zupa, która świetnie smakuje także na drugi dzień, gdy smaki się przegryzą.",
    "image": "Zupy/zupa_soczewicowa.jpg",
    "preparation": "Przygotowanie warzyw: Cebule obierz i pokrój w drobną kostkę. Czosnek obierz i drobno posiekaj lub przeciśnij przez praskę. Ziemniaki obierz, umyj i pokrój w średniej wielkości kostkę. Gotowanie soczewicy: Soczewicę dokładnie wypłucz pod bieżącą wodą. W dużym garnku umieść soczewicę, cebulę, ziemniaki oraz czosnek. Zalej całość bulionem. Dodaj wszystkie przyprawy: paprykę wędzoną, liście laurowe, ziele angielskie, pieprz, sos sojowy, majeranek, lubczyk, natkę pietruszki oraz kolendrę. Dopraw solą do smaku. Gotowanie zupy: Doprowadź zupę do wrzenia na średnim ogniu. Po zagotowaniu zmniejsz ogień do minimum, aby zupa delikatnie pyrkała. Gotuj przez około 20-25 minut, aż soczewica i ziemniaki będą miękkie. Finalizacja: Dopraw jeszcze raz majerankiem, solą i pieprzem do smaku. Podanie: Zupa smakuje wyśmienicie również na drugi dzień, gdy smaki się przegryzą.",
    "ingredients": [
      "Gotowy wywar {LINK} lub bulion {LINK}",
      "2 średnie cebule",
      "3 ziemniaki",
      "1 ząbek czosnku",
      "2 szklanki (400 g) czerwonej soczewicy",
      "1½ łyżeczki papryki wędzonej",
      "2 liście laurowe",
      "2 ziarna ziela angielskiego",
      "2 ziarna czarnego pieprzu",
      "Opcjonalnie: 1½ łyżki sosu sojowego",
      "1 łyżka majeranku suszonego",
      "½ łyżeczki lubczyku suszonego",
      "½ łyżeczki natki pietruszki suszonej",
      "¼ łyżeczki kolendry mielonej",
      "Sól i pieprz do smaku"
    ].join("\n"),
    "path": "zupy"
  },
  
  {
    "id": "zupa-8",
    "name": "Fasolka po bretońsku w wersji wege",
    "category": "ZUPY",
    "shortDesc": "Klasyk, który idealnie wkomponowuje się w naszą wymagającą dietę.",
    "fullDesc": "Fasolka po bretońsku w wersji wege to pyszna alternatywa dla tradycyjnego dania, która doskonale wpisuje się w naszą dietę. Zamiast mięsa, wykorzystujemy pełnię smaku warzyw, aromatycznych przypraw, takich jak wędzona papryka, kminek czy kolendra. To danie jest sycące, zdrowe i pełne smaku. Przepis inspirowany Jadłonomią.",
    "image": "Zupy/fasolka.jpg",
    "preparation": "1. Namaczanie fasoli:\nFasolę odcedź po namoczeniu.\n\n2. Gotowanie fasoli:\nUmieść fasolę, seler, połówkę cebuli, marchewkę, goździk, olej, 1 łyżeczkę soli himalajskiej w dużym garnku i wlej dużo świeżej wody. Gotuj pod przykryciem na małym ogniu przez 30-40 minut, aż fasola będzie miękka.\n\n3. Odcedzanie fasoli:\nNa koniec odcedź fasolę na dużym durszlaku, nad miską (nie wylewaj wody z gotowania!!!).\n\n4. Przygotowanie cebuli:\n Pozostałe 2 cebule pokrój w kostkę.\n\n5. Gotowanie cebuli:\nW tym samym garnku, w którym gotowała się fasola, dodaj cebulę, liście laurowe i ziele angielskie.\n Gotuj z połową szklanki (lub więcej jeśli potrzeba) wody z gotowania fasoli na średnim ogniu przez 4-5 minut, co chwilę mieszając, aż cebula zrobi się miękka.\n\n6. Dodawanie przypraw:\nW tym czasie posiekaj drobniutko czosnek, dodaj do cebuli razem z wędzoną papryką, kolendrą oraz kminkiem.\n Zamieszaj i gotuj kolejne 1-2 minuty.\n\n7. Łączenie składników:\n Dodaj ugotowaną fasolę, passatę pomidorową, sos sojowy lub aminos kokosowy (jesli używasz), szklankę wody pozostałej z gotowania fasoli i wszystkie pozostałe przyprawy: majeranek, lubczyk, natkę pietruszki i sól himalajską.\n Wszystko wymieszaj\nGarnek przykryj i gotuj przez 10-15 minut na małym ogniu.\n\n8. Doprawianie:\nNa koniec spróbuj i w razie potrzeby dopraw jeszcze solą himalajską i pieprzem oraz dolej więcej wody z gotowania fasoli żeby uzyskać preferowaną gęstość.\n\n\nZdrowego! 🌱✨💚",
    "ingredients": [
      "600 g fasoli namoczonej przez noc",
      "½ cebuli + 2 cebule",
      "1 mała marchewka",
      "kawałek bulwy selera",
      "1 goździk",
      "1 łyżeczka oleju roślinnego wysokiej jakości",
      "3 liście laurowe",
      "3 ziarna ziela angielskiego",
      "2 ząbki czosnku",
      "2 łyżeczki papryki wędzonej",
      "¼ łyżeczki kolendry mielonej",
      "¼ łyżeczki kminku mielonego",
      "500 g passaty pomidorowej",
      "Opcjonalnie: 2 łyżki sosu sojowego bez pszenicy lub aminosu kokosowego (alternatywa na bazie kokosa)",
      "1 łyżeczka majeranku",
      "½ łyżeczki lubczyku",
      "½ łyżeczki natki pietruszki",
      "Sól himalajska lub inna wysokiej jakości i pieprz, do smaku"
    ].join("\n"),
    "path": "zupy"
  },

  {
    "id": "zupa-9",
    "name": "Prosta zupa dyniowa",
    "category": "ZUPY",
    "shortDesc": "Aromatyczna zupa dyniowa na rosole z upieczoną dynią.",
    "fullDesc": "Prosta zupa dyniowa to wyjątkowy, aromatyczny przepis, który idealnie wykorzystuje resztki rosołu. Upieczona dynia Hokkaido nadaje zupie głęboki smak, a przyprawy takie jak pieprz ziołowy, oregano i pieprz czarny tworzą harmonijną kompozycję. Szybka i zdrowa propozycja na ciepły posiłek, pełna witamin, idealna na chłodne dni. Prosty sposób przygotowania sprawia, że zupa jest szybka w wykonaniu, a smak sezonowej dyni zachwyca.",
    "image": "Zupy/zupa.jpg",
    "preparation": "Pieczenie dyni: Przekrój dynię na pół, usuń nasiona i piecz ze skórą przez około 30 minut w temperaturze 180°C. Obieranie dyni: Po upieczeniu zdejmij skórę z dyni. Blendowanie: Dodaj upieczoną dynię do bulionu i zblenduj całość na gładki krem. Bulion dodawaj stopniowo, aż do uzyskania zadowalającej konsystencji. Doprawianie: Dopraw zupę pieprzem ziołowym, oregano i pieprzem czarnym do smaku. Smacznego!",
    "ingredients": [
      "Gotowy wywar {LINK} lub bulion {LINK}",
      "1 sztuka sporej dyni Hokkaido",
      "Pieprz ziołowy do smaku",
      "Oregano do smaku",
      "Pieprz czarny do smaku"
    ].join("\n"),
    "path": "zupy"
  },

  {
    "id": "zupa-10",
    "name": "Pomidorówka (wersja zimowa)",
    "category": "ZUPY",
    "shortDesc": "Klasyczna zupa z przecierem pomidorowym.",
    "fullDesc": "Pomidorówka w wersji zimowej to pyszna, rozgrzewająca zupa, która wprowadza smak lata nawet w chłodne dni. Dzięki blendowanej marchewce i przecierowi pomidorowemu, zupa ma głęboki smak, a jej konsystencja jest delikatnie gęstsza, ale jednocześnie kremowa i sycąca. Możliwość podania jej z osobno ugotowanym ryżem brązowym dodaje jej pełnowartościowego charakteru. Idealna na zimowe dni, pełna witamin i smaku!",
    "image": "Zupy/pomidorowka.jpg",
    "preparation": "Przygotowanie wywaru: Ugotuj wywar według przepisu. Z wywaru zachowaj ugotowane marchewki. Blendowanie: Marchewki z wywaru zblenduj z przecierem pomidorowym na gładką masę. Połączenie z wywarem: Przecedź wywar, a następnie dodaj do niego zblendowaną masę marchewkowo-pomidorową. Wymieszaj wszystko razem, dopraw solą i pieprzem do smaku. Jesli używasz, dodaj ugotowane mięso pokrojone na drobniejsze kawałki. Gotowanie ryżu: Ugotuj ryż brązowy osobno, według instrukcji na opakowaniu. Ugotowany ryż możesz również dodać bezpośrednio do garnka z gotową zupą, jeśli wolisz, aby zupa była bardziej sycąca. Podanie: Podawaj gorącą pomidorówkę z ryżem brązowym.",
    "ingredients": [
      "Gotowy wywar {LINK} lub bulion {LINK}",
      "2-3 ugotowane marchewki z wywaru",
      "Opcjonalnie: ugotowane mięso z bulionu oddzielone od kości",
      "Przecier pomidorowy dobrej jakości",
      "Ryż brązowy (ugotowany osobno i dodany do zupy)"
    ].join("\n"),
    "path": "zupy"
  },



  {
    "id": "zupa-11",
    "name": "Pomidorowa ze świeżych pomidorów (wersja letnia)",
    "category": "ZUPY",
    "shortDesc": "Lekka, aromatyczna pomidorowa zupa letnia z świeżych pomidorów.",
    "fullDesc": "Pomidorowa wersja letnia to pyszna, lekka zupa, która zachowuje naturalną świeżość pomidorów. Zamiast smażenia, wykorzystujemy gotowanie i blendowanie, co nadaje jej gładką konsystencję i pełny smak. Dodatek świeżych ziół i marchewki wprowadza do zupy subtelną słodycz, tworząc idealne połączenie. Jest to zdrowa, aromatyczna zupa, która doskonale sprawdzi się na lato, serwowana z ryżem.",
    "image": "Zupy/zupa.jpg",
    "preparation": "Blanszowanie pomidorów: W czajniku zagotuj wodę. Pomidorom natnij skórkę na krzyż. Włóż je do miski, zalej wrzątkiem i pozostaw na minutę. Następnie wylej wrzątek, zalej pomidory zimną wodą i po chwili zdejmuj skórkę. Przygotowanie pomidorów: Obrane pomidory pokrój na ósemki i przełóż do garnka. Gotowanie pomidorów: Do garnka z pomidorami dodaj przecedzony wywar warzywny i zagotuj. Gotuj przez około 15-20 minut, aż pomidory zaczną się rozpadać. Blendowanie: Do gotującego się wywaru z pomidorami dodaj wcześniej odłożone ugotowane marchewki. Zblenduj wszystko razem na gładką masę za pomocą blendera ręcznego. Doprawianie: Dopraw zupę solą, pieprzem, a następnie dodaj połówkę cebuli oraz gałązkę wybranych ziół (np. koper, pietruszka lub seler naciowy). Gotuj na małym ogniu przez kolejne 10 minut, aby zupa nabrała aromatu. Podanie: Podawaj z mleczkiem kokosowym, posypaną świeżymi ziołami oraz z ugotowanym ryżem. Smacznego!",
    "ingredients": [
      "Gotowy wywar {LINK}",
      "2-3 ugotowane marchewki z wywaru",
      "1 kg+ świeżych pomidorów",
      "Sól do smaku",
      "Do podania: Mleczko kokosowe; posiekane zioła (np. bazylia, koper, natka pietruszki)",
      "Ryż brązowy (ugotowany osobno i dodany do zupy)"
    ].join("\n"),
    "path": "zupy"
  },
  
  
  
  
  

]

export default Zupy;
